import React, { Component } from 'react'
import store from '../store'
import { observer } from 'mobx-react'

/** 首页模块权限HOC */
export default function(moduleName) {
  return function(Module) {
    class AuthModule extends Component {
      render() {
        const show = store.showModules.includes(moduleName)
        return show && <Module />
      }
    }
    return observer(AuthModule)
  }
}

export * from './constant'
